export default __webpack_public_path__ + "static/media/Group4790.d023a373.svg";